// HashtagCategoryList.jsx
import React, { useEffect, useCallback } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import { SanitizedLink as Link } from '../component/SanitizedLink.jsx';
import HashtagCategoryItem from '../container/HashtagCategoryItem.js';
import { searchType } from '../resource/searchConstants.js';
import { TranslationNamespace } from '../resource/translationNamespace.js';
import media from '../style/media.js';
import ArrowIconSrc from '../../img/ic-arrow-right-xs.svg';

export const HashtagCategoryList = ({
  t,
  meId = null,
  category = '',
  trendingHashtagFeed = null,
  trendingCategoryFeed = null,
  trendingCategoryFetchLimit = 15,
  shouldRefresh = false,
  items = [],
  fetchTranslationByKey = () => null,
  fetchFeeds = () => null,
  isTrendingMessageCategory = false,
}) => {
  let toUrl;
  const fetchData = useCallback(
    ({ shouldSkipLocalCache } = {}) => {
      if (isTrendingMessageCategory) {
        fetchTranslationByKey({
          groups: [trendingCategoryFeed],
        });
        fetchFeeds({
          type: trendingCategoryFeed,
          limit: trendingCategoryFetchLimit,
          shouldSkipLocalCache,
        });
      } else if (trendingHashtagFeed) {
        fetchTranslationByKey({
          groups: [trendingHashtagFeed],
        });
        fetchFeeds({
          type: trendingHashtagFeed,
          limit: 20,
          shouldSkipLocalCache,
        });
      }
    },
    [
      fetchFeeds,
      fetchTranslationByKey,
      trendingHashtagFeed,
      trendingCategoryFeed,
      trendingCategoryFetchLimit,
      isTrendingMessageCategory,
    ]
  );

  useEffect(() => {
    fetchData();
  }, [fetchData, meId]);

  useEffect(() => {
    if (shouldRefresh) {
      fetchData({ shouldSkipLocalCache: shouldRefresh });
    }
  }, [fetchData, shouldRefresh]);

  if (isTrendingMessageCategory) {
    toUrl = '/category-overview';
  } else {
    toUrl = `/search/${searchType.FLIX}`;
  }
  if (!items?.length) return null;

  return (
    <StyledHashtagCategoryList>
      <HashtagItems>
        {items.map((item, index) => (
          <HashtagCategoryItem
            key={item}
            item={item}
            index={index}
            feedId={category}
            isMessageCategory={isTrendingMessageCategory}
          />
        ))}
      </HashtagItems>
      <MoreButton to={toUrl}>
        <MoreText>
          {t('more', {
            ns: TranslationNamespace.GENERAL,
          })}
        </MoreText>
        <img src={ArrowIconSrc} alt="more" width="16" height="16" />
      </MoreButton>
    </StyledHashtagCategoryList>
  );
};

HashtagCategoryList.propTypes = {
  t: PropTypes.func.isRequired,
  items: PropTypes.array,
  meId: PropTypes.string,
  category: PropTypes.string,
  trendingHashtagFeed: PropTypes.string,
  trendingCategoryFeed: PropTypes.string,
  trendingCategoryFetchLimit: PropTypes.number,
  shouldRefresh: PropTypes.bool,
  fetchTranslationByKey: PropTypes.func,
  fetchFeeds: PropTypes.func,
  isTrendingMessageCategory: PropTypes.bool,
};

const StyledHashtagCategoryList = styled.div`
  display: flex;
  background-color: #191919;
`;

const HashtagItems = styled.div`
  padding-left: 16px;
  display: flex;
  flex-wrap: nowrap;

  overflow-x: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;

  ::-webkit-scrollbar {
    display: none;
  }
`;

const MoreButton = styled(Link)`
  padding-left: 12px;
  padding-right: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  opacity: 0.7;
  :hover {
    opacity: 0.5;
  }
  > img {
    width: 20px;
    height: 20px;
  }
`;

const MoreText = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: rgba(255, 255, 255);
  white-space: nowrap;
  margin-right: 4px;
  ${media.tablet`
    font-size: 14px;
  `};
`;

export default withTranslation()(HashtagCategoryList);
